import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="picker"
export default class extends Controller {
  static targets = ["input", "videoId", "thumbnail"];
  static outlets = ["modal"];

  select({ params: { url, videoId, thumbnail } }) {
    this.inputTarget.value = url;
    if (this.hasVideoIdTarget) {
      this.videoIdTarget.value = videoId;
    }
    if (this.hasThumbnailTarget) {
      this.thumbnailTarget.value = thumbnail;
    }
    if (this.hasModalOutlet) {
      this.modalOutlets.forEach((modal) => modal.close());
    }
  }
}
